enum ControlType  {
  GreenTick = 0,
  CheckBox = 1,
  a = 2,
  label = 3,
  CheckBoxAndLabel = 4,
}
export default Object.freeze(ControlType);

